import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { IBreadcrumb } from './Ibreadcrumb';

@Component({
    selector: 'trg-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent {
    @Input() breadcrumbsList: IBreadcrumb[];
    @Input() set jsonLD(value) {
        this.setSafeHTML(value);
    }
    @Output() pageIndex = new EventEmitter<number>();
    public html: SafeHtml;

    constructor(private sanitizer: DomSanitizer) {}

    public goToPage(e: Event, index: number) {
        if (e && e.preventDefault) {
            e.preventDefault();
        }
        this.pageIndex.emit(index);
    }

    private setSafeHTML(jsonLD: { [key: string]: any }): void {
        if (!jsonLD) return null;
        const json = jsonLD ? JSON.stringify(jsonLD, null, 2).replace(/<\/script>/g, '<\\/script>') : '';
        const html = `<script type="application/ld+json">${json}</script>`;
        this.html = this.sanitizer.bypassSecurityTrustHtml(html);
    }
}
